import { apiUrl as API_BASE_URL } from 'config';
import UserProfile from "components/UserProfile/UserProfile";
import axios from 'axios';
import { create, filter } from 'd3';
import { param } from 'jquery';

// Create an axios instance with a base URL and authentication header
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}` // Assuming JWT auth
    }
});

export const briefingTrailersAPI = {
    getAll: () => api.get('briefing/safety-trailers/'),
    filter: (params) => api.get('briefing/safety-trailers/', { params }),
    getArchive: (params) => api.get('briefing/safety-trailers/get-archives/', { params }),
    getHistory: (params) => api.get('briefing/safety-trailers/history/', { params }),
    create: (data) => api.post('briefing/safety-trailers/', data),
    update: (id, data) => api.put(`briefing/safety-trailers/${id}/`, data),
    delete: (id) => api.delete(`briefing/safety-trailers/${id}/`),
};

export const briefingTrucksAPI = {
    getAll: () => api.get('briefing/safety-trucks/'),
    filter: (params) => api.get('briefing/safety-trucks/', { params }),
    getArchive: (params) => api.get('briefing/safety-trucks/get-archives/', { params }),
    getHistory: (params) => api.get('briefing/safety-trucks/history/', { params }),
    create: (data) => api.post('briefing/safety-trucks/', data),
    update: (id, data) => api.put(`briefing/safety-trucks/${id}/`, data),
    delete: (id) => api.delete(`briefing/safety-trucks/${id}/`),
};

export const briefingTeamUpdatesAPI = {
    getAll: () => api.get('briefing/team-updates/'),
    filter: (params) => api.get('briefing/team-updates/', { params }),
    getArchive: (params) => api.get('briefing/team-updates/get-archives/', { params }),
    getHistory: (params) => api.get('briefing/team-updates/history/', { params }),
    create: (data) => api.post('briefing/team-updates/', data),
    update: (id, data) => api.put(`briefing/team-updates/${id}/`, data),
    delete: (id) => api.delete(`briefing/team-updates/${id}/`),

    getTransferAssignments: (team) => api.get('briefing/team-updates/get-transfer-assignments/', { params: { team } }),
    getUnconfirmedDeliveryTimeOrders: (team) => api.get('briefing/team-updates/get-unconfirmed-delivery-time-orders/', { params: { team } }),
};

export const quotingHeadTableAPI = {
    getAll: () => api.get('briefing/quoting-head/'),
    filter: (params) => api.get('briefing/quoting-head/', { params }),
    getArchive: (params) => api.get('briefing/quoting-head/get-archives/', { params }),
    getHistory: (params) => api.get('briefing/quoting-head/history/', { params }),
    create: (data) => api.post('briefing/quoting-head/', data),
    update: (id, data) => api.put(`briefing/quoting-head/${id}/`, data),
    delete: (id) => api.delete(`briefing/quoting-head/${id}/`),
};

export const trackAndTraceHeadTableAPI = {
    getAll: () => api.get('briefing/track-and-trace-head/'),
    filter: (params) => api.get('briefing/track-and-trace-head/', { params }),
    getArchive: (params) => api.get('briefing/track-and-trace-head/get-archives/', { params }),
    getHistory: (params) => api.get('briefing/track-and-trace-head/history/', { params }),
    create: (data) => api.post('briefing/track-and-trace-head/', data),
    update: (id, data) => api.put(`briefing/track-and-trace-head/${id}/`, data),
    delete: (id) => api.delete(`briefing/track-and-trace-head/${id}/`),
};

export const loadPlanningHeadTableAPI = {
    getAll: () => api.get('briefing/load-planning-head/'),
    filter: (params) => api.get('briefing/load-planning-head/', { params }),
    getArchive: (params) => api.get('briefing/load-planning-head/get-archives/', { params }),
    getHistory: (params) => api.get('briefing/load-planning-head/history/', { params }),
    create: (data) => api.post('briefing/load-planning-head/', data),
    update: (id, data) => api.put(`briefing/load-planning-head/${id}/`, data),
    delete: (id) => api.delete(`briefing/load-planning-head/${id}/`),
};

// Add request interceptor to include the token dynamically before each request
api.interceptors.request.use(async (config) => {
    const token = await UserProfile.getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;  // Include token in Authorization header
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
